/**
 * Campus quick-picks: coordinates from Google Places "Find Place From Text"
 * (legacy Places API), biased to circle:2500m @ 33.7756,-84.3963.
 * Re-fetch if pins drift: see repo scripts or curl findplacefromtext + these queries.
 */
export const CAMPUS_QUICK_LOCATIONS = [
  {
    name: 'North Avenue Apartments',
    address: '120 North Ave NW, Atlanta, GA',
    latitude: 33.7695606,
    longitude: -84.3909922,
    keywords: ['north ave', 'naa', 'apartments', 'techwood']
  },
  {
    name: 'Campus Recreation Center',
    address: '750 Ferst Dr, Atlanta, GA',
    latitude: 33.7755602,
    longitude: -84.4035651,
    keywords: ['crc', 'gym', 'rec center', 'recreation']
  },
  {
    name: 'Clough Undergraduate Learning Commons (CULC)',
    address: '266 4th St NW, Atlanta, GA',
    latitude: 33.7749203,
    longitude: -84.3964148,
    keywords: ['culc', 'clough', 'learning commons']
  },
  {
    name: 'Price Gilbert Memorial Library',
    address: '704 Cherry St NW, Atlanta, GA',
    latitude: 33.7743675,
    longitude: -84.3956421,
    keywords: ['library', 'price gilbert', 'gilbert', 'crosland']
  },
  {
    name: 'Klaus Advanced Computing Building',
    address: '266 Ferst Dr NW, Atlanta, GA',
    latitude: 33.7770292,
    longitude: -84.3958151,
    keywords: ['klaus', 'computing']
  },
  {
    name: 'Scheller College of Business',
    address: '800 W Peachtree St NW, Atlanta, GA',
    latitude: 33.776421,
    longitude: -84.3877407,
    keywords: ['scheller', 'business', 'tech square']
  },
  {
    name: 'John Lewis Student Center',
    address: '351 Ferst Dr NW, Atlanta, GA',
    latitude: 33.7737704,
    longitude: -84.3990195,
    keywords: ['student center', 'jlsc', 'dining', 'food court']
  },
  {
    name: 'Van Leer Building (ECE)',
    address: '777 Atlantic Dr NW, Atlanta, GA',
    latitude: 33.7758809,
    longitude: -84.3970653,
    keywords: ['van leer', 'ece', 'electrical']
  }
];

export function filterCampusQuickLocations(query) {
  const q = query.trim().toLowerCase();
  if (!q) {
    return CAMPUS_QUICK_LOCATIONS;
  }
  return CAMPUS_QUICK_LOCATIONS.filter((loc) => {
    const blob = [loc.name, loc.address, ...(loc.keywords || [])]
      .join(' ')
      .toLowerCase();
    return blob.includes(q);
  });
}

export function toCampusPrediction(loc) {
  return {
    description: loc.name,
    structured_formatting: {
      main_text: loc.name,
      secondary_text: loc.address
    },
    campusQuickPick: true,
    name: loc.name,
    address: loc.address,
    latitude: loc.latitude,
    longitude: loc.longitude
  };
}
